import i18next from "i18next";
import axios, {simpleErrorHandling} from "config/network";

const getZohoSettings = async () => {
    try {
        const response = await axios.get(
            `/api/v1/GeneralSettings/zoho-settings?culture=${i18next.language}`);
        return response.data;
    } catch (err) {
        if (err.message) {
            throw err;
        } else {
            throw new Error("Failed to get Zoho settings");
        }
    }
};

const getZohoSrc = async () => {
    try {
        const response = await axios.get('/api/v1/owner/settings/ZohoURL')
        const {data} = response.data
        return data

    } catch (err) {
        if (err.message) {
            throw err;
        } else {
            throw new Error("Failed to get Zoho src");
        }
    }
}

const submitZohoTicketForm = async (body) => {
    try {
        const response = await axios.post('/api/v1/Support/ticket', body)
        return response.data

    } catch (err) {
        simpleErrorHandling(err, 'The ticket is not submitted')
    }
}

export const zohoService = {
    getZohoSettings,
    getZohoSrc,
    submitZohoTicketForm

};
